import { makeAutoObservable } from 'mobx'
import WebSocketService from '../../../../../services/WebSocketService'

export interface Permissions {
  installationOrder?: {
    canCreateOrder?: boolean
    canCreateLoadedByOperatorOrder?: boolean
  }
  [key: string]: any // Другие возможные разрешения
}

export interface UserInfo {
  id?: string
  displayRole?: string | null
  displayName?: string
  permissions?: Permissions
  roles?: string[]
}

class UserInfoStore {
  info: UserInfo = {}
  roles: string[] = []
  permissions: Permissions = {}

  private readonly wsConnection: typeof WebSocketService
  public readonly wsKey = 'UserInfoStore'

  constructor() {
    this.wsConnection = WebSocketService
    makeAutoObservable(this)
  }

  setUserInfo = (info: UserInfo): void => {
    this.info = info
    this.permissions = info.permissions ?? {}
    this.roles = info.roles ?? []

    this.wsConnection.setSubscribe(
      this.wsKey,
      (data: { permissions?: Permissions }) => {
        if (data?.permissions) {
          this.permissions = {
            ...this.permissions,
            ...data.permissions,
          }
        }
      }
    )
  }
}

export const userInfoStore = new UserInfoStore()
